import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material'; // Import Material-UI components
import articlesData from './supportArticles.json'; // Adjust the path as necessary

const Blog = () => {
  // Get the articleId from the URL parameters
  const { articleId } = useParams();

  // Find the article by id
  const article = articlesData.find(article => article.id === parseInt(articleId));

  // Handle case where article doesn't exist
  if (!article) {
    return (
      <Box sx={{ padding: 3 }}>
        <Typography variant="h6" color="error">
          Article not found
        </Typography>
      </Box>
    );
  }

  return (
    <Box 
      sx={{ 
        padding: 3,
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9'
      }}
    >
      <Typography variant="h5" component="h2" gutterBottom>
        {article.title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {article.description}
      </Typography>
      {/* You can add more content related to the article here */}
    </Box>
  );
};

export default Blog;
